const styles = {
    iconColor: { color: "primary.main1" },
};

export default styles;
